/**
 * Supabase JS's FunctionsHttpError only exposes a generic message
 * ("Edge Function returned a non-2xx status code") on `.message` -- the
 * actual JSON `{ error: "..." }` body the Edge Function returned is only
 * reachable via `.context`, a Response object whose body hasn't been read
 * yet. This extracts that real message when available, falling back to
 * the generic message (or a caller-supplied fallback) for non-JSON bodies,
 * already-consumed responses, or any other parse failure.
 */
export async function extractEdgeFunctionErrorMessage(
  error: any,
  fallback: string
): Promise<string> {
  try {
    if (error?.context && typeof error.context.json === 'function') {
      const body = await error.context.json();
      if (body && typeof body.error === 'string' && body.error.trim()) {
        return body.error;
      }
    }
  } catch {
    // Not JSON, body already consumed, or some other parse failure --
    // fall through to the generic message below.
  }
  return error?.message || fallback;
}
